import Environment from '@ezcater/env-vars';

type Environments = 'test' | 'development' | 'dev1' | 'staging' | 'production';

type AppConfig = {
  appBuildId?: string;
  appEnvironment: Environments;
  datadogRumAppId: string | null;
  datadogRumClientId: string | null;
  graphqlHost: string;
  rudderstackConfigUrl: string;
  rudderstackDataPlaneUrl: string;
  rudderstackEnabled: boolean;
  rudderstackSdkBaseUrl: string;
  rudderstackWriteKey: string;
  sentryDsn: string | null;
};

const appConfig: AppConfig = {
  appBuildId: process.env.REACT_APP_BUILD_ID,
  appEnvironment: Environment.fetch('APP_ENVIRONMENT', 'production') as Environments,
  datadogRumAppId: Environment.fetch('DATADOG_RUM_APP_ID', null),
  datadogRumClientId: Environment.fetch('DATADOG_RUM_CLIENT_ID', null),
  graphqlHost: Environment.fetch('GRAPHQL_HOST'),
  rudderstackConfigUrl: Environment.fetch('RUDDERSTACK_CONFIG_URL', ''),
  rudderstackDataPlaneUrl: Environment.fetch('RUDDERSTACK_DATA_PLANE_URL', ''),
  rudderstackEnabled: Environment.fetch('RUDDERSTACK_ENABLED', null) === 'true',
  rudderstackSdkBaseUrl: Environment.fetch('RUDDERSTACK_SDK_BASE_URL', ''),
  rudderstackWriteKey: Environment.fetch('RUDDERSTACK_WRITE_KEY', ''),
  sentryDsn: Environment.fetch('SENTRY_DSN', null),
};

export default Object.freeze(appConfig);
